/**
 * Google Pay API
 * Payment session management for Google Pay
 */

import { apiRequest } from './core';

// ============================================================================
// Types
// ============================================================================

export interface PaymentSessionResponse {
  payment_session: {
    id: string;

    _links?: any;
    payment_session_token?: string;
    payment_session_secret?: string;
  };
  public_key: string;
  environment: string;
}

// ============================================================================
// API Functions
// ============================================================================

/**
 * Create payment session for Google Pay
 */
export const createPaymentSession = async (
  paymentSourceId: number,
  userCreditId: number,
  rcToken: string,
  fxRate?: number,
  currency?: string
): Promise<PaymentSessionResponse> => {
  const requestBody: Record<string, unknown> = {
    user_credit_id: userCreditId,
    rc_token: rcToken,
    ...(currency && { currency }),
    ...(fxRate && { fx_rate: fxRate })
  };

  return apiRequest<PaymentSessionResponse>(
    `/my/payment_sources/${ paymentSourceId }/payment_sessions`,
    {
      method: 'POST',
      body: requestBody
    }
  );
};

/**
 * Process payment session payment (after Google Pay completion)
 */
export const processPaymentSessionPayment = async (
  paymentSourceId: number,
  paymentSessionId: string,
  userCreditId: number,
  paymentId: string
): Promise<any> => {
  const requestBody = {
    user_credit_id: userCreditId,
    payment_id: paymentId
  };

  return apiRequest<any>(
    `/my/payment_sources/${ paymentSourceId }/payment_sessions/${ paymentSessionId }`,
    {
      method: 'PUT',
      body: requestBody
    }
  );
};
